// extracted by mini-css-extract-plugin
export default {"root":"ContactBroker_root__f2J2e","boldMessage":"ContactBroker_boldMessage__B-qVM","message":"ContactBroker_message__xgbKQ","link":"ContactBroker_link__lk1+o"};